<template>
  <!--
    外层 ca-layout-ie 是 IE11 兼容壳（flexbugs #3）：IE 里「列向 flex 容器 + min-height」
    不会把高度传给子项，flex:1 的正文撑不开、页脚会上漂到导航下。
    套一层列向 flex 父容器，让 .ca-layout 以 flex 子项身份拿到确定高度。
  -->
  <div class="ca-layout-ie">
    <div class="ca-layout">
      <ca-header :nav="nav" />
      <div class="ca-layout__body">
        <router-view />
      </div>
      <footer class="ca-layout__footer" :style="{ background: navBgColor }">
        <div class="ca-layout__footer-inner">
          <router-link class="ca-layout__footer-contact" :to="{ name: 'ca-contact' }">联系我们</router-link>
          <span>© 2014-2019 上海汇招信息技术有限公司版权所有沪ICP备12042911号-1</span>
        </div>
      </footer>
      <login-dialog />
    </div>
  </div>
</template>

<script>
import CaHeader from './CaHeader.vue'
import LoginDialog from '../login/LoginDialog.vue'
import { getApplyNav } from '@/api/ca'
import { isLogin } from '@/shared/user'

export default {
  name: 'CaLayout',
  components: { CaHeader, LoginDialog },
  data() {
    return {
      navInfo: null, // 顶栏品牌信息（/zcjf/ca/apply/nav）；拉取失败保持 null，顶栏走默认 #333 + 无品牌
    }
  },
  computed: {
    // 顶栏品牌信息（平台名 / 主题色 / logo / 官网链接）；接口未就绪时给空对象兜底走默认样式
    nav() {
      return this.navInfo || {}
    },
    // 页脚底色：与顶栏同一口径（客户主题色，未配置默认 #333），保证头尾一致
    navBgColor() {
      return this.nav.bgColor || '#333'
    },
    // 当前客户编码：由路由守卫解析后写入 store，这里监听它的变化重新拉顶栏配置
    customerCode() {
      return this.$store.state.ca.customerCode
    },
  },
  watch: {
    customerCode: {
      immediate: true,
      handler(code) {
        // 客户编码变化（含首次进入）→ 按新客户重新拉取顶栏品牌
        if (code) this.loadNav(code)
      },
    },
  },
  created() {
    // 刷新后登录态以 token 为准（见 shared/user.isLogin），但顶栏展示的手机号 name
    // 只来自 getInfo / localStorage。持久化状态缺失时 name 为空，这里从服务端回填；
    // getInfo 返回 401 时由 http 拦截器统一清 token 并弹登录框，无需额外处理。
    if (isLogin() && !this.$store.getters.name) {
      this.$store.dispatch('user/getInfo').catch(() => {})
    }
  },
  methods: {
    // 顶栏导航（apply/nav）失败只影响品牌展示，不阻塞页面；错误提示由请求拦截器统一处理，无需 catch
    loadNav(code) {
      const c = code || this.customerCode
      if (!c) return
      getApplyNav({ customerCode: c }).then((res) => {
        this.navInfo = res.data
      })
    },
  },
}
</script>

<style lang="scss">
// CA 模块全部样式集中在 style/ca.scss（含本布局与各页面/组件/弹框、element 主题覆盖），
// 此处非 scoped 一次性引入；所有类统一 ca- 前缀，不污染主站其他页面。
@import '../style/ca.scss';
</style>
